export const environment = {
  production: true,
  baseUrl:'https://apiunify.academia.cl/bolsa_trabajo',
  token: 'fjEhYbAg.Aeq69kBQn4KVOVfD7AlwtPI0HSbnikO1'

};
